<template>
  <v-container fluid class="pa-0 ma-0 py-10 top-section" id="contact">
    <v-row justify="center" align="center" class="ma-0 pa-0 py-4 header text-center">
      <v-col cols="12">
        <span class="display-1 font-weight-medium white--text">Contact me</span>
      </v-col>
    </v-row>
    <v-row justify="center" class="text-center white--text">
      <v-col cols="12" md="4">
        <v-icon color="white" large class="mx-5">mdi-email</v-icon>quentin.mennecart@gmail.com
      </v-col>
      <v-col cols="12" md="4">
        <v-icon color="white" large class="mx-5" @click="goTo('twitter')">mdi-twitter</v-icon>
        <v-icon color="white" large class="mx-5" @click="goTo('linkedin')">mdi-linkedin</v-icon>
        <v-icon color="white" large class="mx-5" @click="goTo('instagram')">mdi-instagram</v-icon>
      </v-col>
      <v-col cols="12" md=4>
        {{ new Date().getFullYear() }} — <strong>Quentin Mennecart</strong>
        <br />Made with ❤ with Vuetify
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  methods: {
    goTo (elem) {
      switch(elem) {
        case 'twitter':
          window.open('https://twitter.com/QuentinMenDev', '_blank')
          break
        case 'linkedin':
          window.open('https://www.linkedin.com/in/quentin-mennecart-a20195110/', '_blank')
          break
        case 'instagram':
          window.open('https://www.instagram.com/quentin.mennecart/', '_blank')
          break
      }
    }
  }
};
</script>

<style scoped>
.top-section {
  background-image: linear-gradient(160deg,#8300e9 0%,#00e2db 88%)!important;
}
</style>
